import React from "react";
import { useStyles } from "./styles";

const Animation = ({ height = "10px", width = "60%", className = "" }) => {
  const classes = useStyles({ height, width });
  return <div className={`${classes.animation} ${className}`} />;
};
export default Animation;
